import React from 'react';
import { StyledSpecialRatesDiv } from './SpecialRates.styles';
import { SpecialRatesProps } from './SpecialRates.types';

const SpecialRates: React.FC<SpecialRatesProps> = () => {
  return (
    <StyledSpecialRatesDiv className="blue-outline">
      {}
    </StyledSpecialRatesDiv>
  );
};

export default SpecialRates;
